import { IListView, IListViewItem } from "@optima-stride-ai/optima-components";
import { iPlan, iPlanItems } from "../progress-plan.model";
import { BizInformationTypes, FieldTypes } from "@optima-stride-ai/core";
import { UtilService } from "../../utils/util.service";

export function getPlanListView(
    data:iPlan,
    utilService:UtilService,
    onEdit?: (planItem: iPlanItems) => void,
    onDelete?: (planItem: iPlanItems) => void
): IListView<iPlan> {
    let colHeadersForPlan = [
        { key: "#", label:"#", cssClass:"label"},
        { key: "date", label:"Date", cssClass:"date-label"},
        { key: "expectedValue", label:"Expected Value", cssClass:"expected-value-label"},
        { key: "unit", label:"Unit", cssClass:"unit-label"},
        { key: "editPlanItem", label:"Edit", cssClass:""},
        { key: "deletePlanItem", label:"Delete", cssClass:""}
    ];

    let listViewItems : IListViewItem<iPlan>[] = getPlanListViewItems(data, utilService, onEdit, onDelete);

    let listView : IListView<iPlan> = {
        title: 'Generated Plan',
        colHeaders: colHeadersForPlan,
        items: listViewItems,
        isStriped: true,
    };

    return listView;
}

function getPlanListViewItems(
    data:iPlan,
    utilService:UtilService,
    onEdit?: (planItem: iPlanItems) => void,
    onDelete?: (planItem: iPlanItems) => void
): IListViewItem<iPlan>[] {
    let listViewItems : IListViewItem<iPlan>[] = [];
    const isLastItem = data.planItems.length === 1;
    for(let i = 0; i < data.planItems.length; i++){
        let d = data.planItems[i];
        let item : IListViewItem<iPlan> = {
            id: d.id,
            columns:[
                { key:"#", label: "L1", value: i+1, metaData: {name: "#", label: "L1", type:FieldTypes.number}, bizInformationType: BizInformationTypes.text },
                { key:"date", label: "Date", value: utilService.convertDateToString(d.date), metaData: {name: "date", label: "Date", type:FieldTypes.date}, bizInformationType: BizInformationTypes.text },
                { key:"expectedValue", label: "Expected Value", value: d.expected, metaData: {name: "expectedValue", label: "Expected Value", type:FieldTypes.number}, bizInformationType: BizInformationTypes.text },
                { key:"unit", label: "Unit", value: d.unit.symbol, metaData: {name: "unit", label: "Unit", type:FieldTypes.text}, bizInformationType: BizInformationTypes.text }
            ],
            actions: [
                {
                    label: 'editPlanItem',
                    icon: 'cilPencil',
                    tooltip: 'Edit',
                    action: () => {
                        if (onEdit) {
                            onEdit(d);
                        }
                    }
                },
                {
                    label: 'deletePlanItem',
                    icon: 'cilTrash',
                    tooltip: isLastItem ? 'Cannot delete the only plan item' : 'Delete',
                    isDisabled: isLastItem,
                    action: () => {
                        if (onDelete) {
                            onDelete(d);
                        }
                    }
                }
            ]
        };

        listViewItems.push(item);
    }

    return listViewItems;
}